import { useState } from "react";
import { Copy, Loader2, Mail, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export function SponsorEmails({ p }) {
  const [emails, setEmails] = useState(p.emails || []);
  const [busy, setBusy] = useState(false);
  const write = async () => {
    setBusy(true);
    try { const r = await api.post(`/funding/bank/${p.package_id}/emails`); setEmails(r.data); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  const copy = (e) => { navigator.clipboard.writeText(`Subject: ${e.subject}\n\n${e.body}`); toast.success("Email copied"); };
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="sponsor-emails">
      <h4 className="font-semibold text-slate-900 text-sm flex items-center gap-2"><Mail className="h-4 w-4 text-emerald-600" />Sponsor outreach emails</h4>
      {!emails.length && <p className="text-xs text-slate-500 mt-1">One ready-to-send email for each suggested sponsor type.</p>}
      <Button onClick={write} disabled={busy || p.status !== "ready"} variant="outline" size="sm" className="mt-3 w-full" data-testid="sponsor-emails-generate-button">
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Send className="h-4 w-4 mr-2" />}{emails.length ? "Rewrite emails" : "Write outreach emails"}</Button>
      <div className="mt-3 space-y-3">
        {emails.map((e, i) => (
          <details key={i} className="border border-slate-200 rounded-md p-3 group" data-testid={`sponsor-email-${i}`}>
            <summary className="cursor-pointer text-xs font-semibold text-slate-800">{e.sponsor_type}<span className="block font-normal text-slate-500">{e.subject}</span></summary>
            <p className="mt-2 text-xs text-slate-700 whitespace-pre-line">{e.body}</p>
            <div className="mt-2 flex gap-3 text-xs">
              <button onClick={() => copy(e)} className="text-emerald-700 font-medium inline-flex items-center gap-1 hover:underline" data-testid={`sponsor-email-${i}-copy`}><Copy className="h-3 w-3" />Copy</button>
              <a href={`mailto:?subject=${encodeURIComponent(e.subject)}&body=${encodeURIComponent(e.body)}`} className="text-emerald-700 font-medium inline-flex items-center gap-1 hover:underline" data-testid={`sponsor-email-${i}-open`}><Mail className="h-3 w-3" />Open in email app</a>
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
